module.exports = "pegasus_template/assets/themecapture1/launch/201.png";